export default "__VITE_ASSET__NxSu3E7k__"